import { render, staticRenderFns } from "./planPicture.vue?vue&type=template&id=38215a50"
import script from "./planPicture.vue?vue&type=script&lang=js"
export * from "./planPicture.vue?vue&type=script&lang=js"
import style0 from "./planPicture.vue?vue&type=style&index=0&id=38215a50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports